import React, { useState, useEffect } from 'react';
import { Button, Input } from 'reactstrap';
import Select from 'react-select';
import _ from 'lodash'
import api from '../../../api';

const defaultImg = 'https://photo2.tinhte.vn/data/attachment-files/2019/07/4728702_7.jpg';

const ContentRow = ({ content, updateCallback, contentCategories }) => {
    const [contentData, setContentData] = useState(content);
    const [isUpdateOk, setIsUpdateOk] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const updateAttr = (attrName, value) => {
        const newContentData = Object.assign({}, contentData);
        newContentData[attrName] = value;
        setContentData(newContentData);
    }
    const updateContent = () => {
        setIsLoading(true);
        api.fetchAPI({
            method: 'put',
            uri: `content/${contentData.external_content_id}`,
            body: contentData,
            success: (response) => {
                if (response.status === 'ok') {
                    setIsUpdateOk(true);
                    setIsLoading(false);
                    if (updateCallback) {
                        updateCallback(contentData);
                    }
                }
            },
            error: (error) => {
              console.error(error);
              setIsLoading(false);
            }
        });
    }
    const setContentOk = () => {
        setIsLoading(true);
        api.fetchAPI({
            method: 'put',
            uri: `content/${contentData.external_content_id}`,
            body: {
                ...contentData,
                is_content_reviewed: 1,
            },
            success: (response) => {
                if (response.status === 'ok') {
                    setIsUpdateOk(true);
                    setIsLoading(false);
                    if (updateCallback) {
                        updateCallback(contentData);
                    }
                }
            },
            error: (error) => {
              console.error(error);
              setIsLoading(false);
            }
        });
    }
    const changeForum = (selectedOption) => {
        const newContentData = Object.assign({}, contentData);
        newContentData.forum_name = selectedOption.label;
        newContentData.forum_id = selectedOption.value;
        setContentData(newContentData);
    }
    return (
        <tr
            style={styles.row}
            className={(contentData.is_content_reviewed || isUpdateOk) && 'content-list__is_content_reviewed'}
        >
            <td className="content-list__title">
                <img
                    className="content-list__image"
                    src={contentData.image_url || defaultImg}
                    alt={contentData.title}
                />
                <div style={styles.titleColumn}>
                    <a
                        href={`https://tinhte.vn/thread/${contentData.external_content_id}`}
                        target="_blank"
                    >
                        {contentData.title}
                    </a>
                    <br />
                    <span style={styles.creatorName}>{contentData.creator_name}</span>
                    <br />
                    <Input
                        style={styles.tagTextbox}
                        value={contentData.tags}
                        onChange={e => updateAttr('tags', e.target.value)}
                    />
                </div>
            </td>
            <td style={styles.forumColumn}>
                <Select
                    value={{
                        label: contentData.forum_name,
                        value: contentData.forum_id,
                    }}
                    options={contentCategories}
                    onChange={changeForum}
                />
            </td>
            <td>
                <div>
                    <Button
                        color={isUpdateOk ? "success" : "primary"}
                        onClick={updateContent}
                        size="sm"
                        disabled={isLoading}
                    >
                        {!isUpdateOk ? isLoading ? 'Updating...' : 'Update' : 'Done'}
                    </Button>
                </div>
                <div style={{ marginTop: 12 }}>
                    {!isUpdateOk &&
                        <Button
                            color="primary"
                            onClick={setContentOk}
                            size="sm"
                        >
                            Đã ok
                        </Button>
                    }
                </div>
            </td>
        </tr>
    );
}

const styles = {
    tagTextbox: {
        marginTop: 12,
    },
    titleColumn: {
        // maxWidth: 300,
    },
    forumColumn: {
        minWidth: 250,
    },
    creatorName: {
        fontSize: 12,
        marginTop: 6,
        color: 'var(--secondary)',
    },
    loadMore: {
        width: '100%',
    },
};

export default ContentRow;


// WEBPACK FOOTER //
// ./src/pages/AIContentEdit/ContentRow/index.js